import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  leftSection?: React.ReactNode,
  rightSection?: React.ReactNode,
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, leftSection, rightSection, ...props }, ref) => {
    return (
      <div className="relative">
        {leftSection ? (
          <span className="absolute left-2 top-0 bottom-0 flex flex-col justify-center text-gray-400">
            {leftSection}
          </span>
        ) : null}
        {rightSection ? (
          <span className="absolute right-2 top-0 bottom-0 flex flex-col justify-center text-gray-400 text-sm">
            {rightSection}
          </span>
        ) : null}

        <input
          type={type}
          className={cn(
            "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            leftSection && "pl-6",
            rightSection && "pr-6",
            className,
          )}
          ref={ref}
          {...props}
        />
      </div>
    );
  }
);
Input.displayName = "Input";

export { Input };
